import { render, staticRenderFns } from "./CardProximaFatura.vue?vue&type=template&id=0e3b348f&scoped=true&"
import script from "./CardProximaFatura.vue?vue&type=script&lang=js&"
export * from "./CardProximaFatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3b348f",
  null
  
)

export default component.exports